module.exports = __webpack_public_path__ + "static/media/help_tools.3149df33.svg";